import OliverText from "@builder/components/general/OliverText";
import TextInput from "@builder/components/general/TextInput";
import { useEffect, useState } from "react";
import "../styles.scss";
import Condition from "../Condition";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useTranslation } from "react-i18next";
import YoutubeButton from "@builder/components/general/Button/YoutubeButton";

const ExplanationBox = ({ isAuto, onClose }: { isAuto: boolean, onClose: ()=>void }) => {
    const { t } = useTranslation();
    return (
        <div className="actions-explanation-wrapper">
            <img className="close" src="/fat-cross.svg" alt="" onClick={onClose} />
            {isAuto ? (
                <>
                    <OliverText text={t("popup.actionBuilder.Auto-triggered actions trigger based on defined conditions.")} size="s" weight="medium" />
                    <OliverText text={t("popup.actionBuilder.The action won't initiate until all conditions are met.")} size="xs" weight="light" />
                </>
            ) : (
                <>
                    <OliverText text={t("popup.actionBuilder.Linking actions to elements makes them clickable")} size="s" weight="medium" />
                    <OliverText text={t("popup.actionBuilder.Clicking a button triggers the linked action.")} size="xs" weight="light" />
                </>
            )}
            <div className="image-details">
                <img src="/video-tutorial.svg" className="video-tutorial-icon" alt="" />
                <OliverText text={"Not sure where to begin?"} size="xs" weight="medium" translatePrefix="popup.actionBuilder." color="blue" />
                <YoutubeButton link={import.meta.env.VITE_YOUTUBE_TUTORIAL_ACTIONS || "https://www.youtube.com/@FinalPOS"} />
            </div>
        </div>
    );
};

const Start = () => {
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor[0]);
    const isAuto = useAppSelector(state => state.popup.isAutomation);
    const [actionName, setActionName] = useState(actionStep?.name || "");
    const [isExplanationOpen, setExplanationOpen] = useState(true);
    const dispatch = useAppDispatch();


    useEffect(() => {
        if (actionStep) {
            let updatedItem;
            if (!isAuto && actionStep.action) {
                updatedItem = { ...actionStep, isAuto: isAuto, name: actionName, action: null };
            } else {
                updatedItem = { ...actionStep, isAuto: isAuto, name: actionName };
            }
            dispatch(updateStepperActions({ id: updatedItem.id as string, item: updatedItem }));
        }
    }, [actionStep, isAuto, actionName, dispatch]);

    return (
        <div className="actions-tab">
            <TextInput callback={setActionName} value={actionName} className="actions-tab-input" placeholder="Enter action name here" noTranslate />
           { isExplanationOpen && <ExplanationBox isAuto={isAuto} onClose={()=>setExplanationOpen(false)}/>}
            {isAuto && <Condition selectedTab={actionStep.id!} key={actionStep.id} isTrigger isAuto/>}
        </div>
    );
};

export default Start;
